import React, {Component} from 'react';
import FJLocalStore from "../../../store/FJLocalStore";
import FJSliderInput from '../../../common/component/slider/FJSliderInput';
import FJDropDown from "fj-components/FJDropDown"
import FJMainColorSwitch from '../../../common/component/FJMainColorSwitch'
import styles from './FJVoice.module.less';
import InlineSVG from "react-inlinesvg";
import FJVolumeIcon from '../../../icon/FJVolumeIcon.svg';
import FJMuteIcon from '../../../icon/FJMuteIcon.svg';
import FJToolbarIconButton from "./FJToolbarIconButton";
import FJUtil from "../../../util/FJUtil";

class FJVoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      muted: false,
    };
    this.slider = React.createRef();
    this.dropDown = React.createRef();
  }

  componentDidMount() {
    this._updateVolume(this.props.volume);
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.volume !== this.props.volume) {
      this._updateVolume(this.props.volume);
    }
  }

  _switchEnableMute(enable) {

    let func = (value) => {
      this._updateVolume(value);
      this._volumeDataChange({type: "slideStart", value});
      this._volumeDataChange({type: "changed", value});
      this._volumeDataChange({type: "slideStop", value});
    };

    if (enable) {
      func(0);
    } else {
      func(100);
    }
  };

  _updateVolume = (value) => {
    this.slider.current.updateSlider(Math.floor(value));
  };
  _volumeDataChange = (data) => {
    this.props.volumeDataChange(data.type, data.value);
  };

  isActive() {
    return this.dropDown.current.isShow();
  }

  onShow = () => {
    let {toggleEventHide} = this.props;
    if (toggleEventHide) {
      toggleEventHide(false);
    }
  };
  onHide = (e) => {
    let {toggleEventHide} = this.props;
    if (toggleEventHide) {
      toggleEventHide(true, e);
    }
  };

  _toggleTooltip = (ele, bool) => {
    FJUtil.toggleTooltip(ele, bool);
  };

  render() {
    let {
      volume,
      disabled,
    } = this.props;
    return (
      <FJDropDown overlay={
        <div className={styles.popup_panel}>
          <FJSliderInput ref={this.slider} sliderID='volumeSlider' callback={this._volumeDataChange}
                         name={FJLocalStore._('volume')} min={0} max={100} value={Math.floor(volume)}/>
          <div className={styles.mute}>
            <div className={styles.mute_label}>{FJLocalStore._('mute')}</div>
            <FJMainColorSwitch active={volume === 0} onChange={(enable) => this._switchEnableMute(enable)} />
          </div>
        </div>
      } ref={this.dropDown}
                  overlayClassName='c-overlay-bg'
                  onShow={this.onShow}
                  onHide={this.onHide}
                  useAnchorBody
                  isTopLayer
                  canTriggerActive
                  disabled={disabled}
                  hasArrow={true}
                  toggleTooltip={this._toggleTooltip}
      >
        <FJToolbarIconButton disabled={disabled}
                             className='u-tooltip-bottom c-toolbar-icon-btn float-left'
                             tooltip={FJLocalStore._('mute') }
                             icon={<InlineSVG src={volume === 0 ? FJMuteIcon : FJVolumeIcon} element='div'/>} />
      </FJDropDown>
    );
  }
}

export default FJVoice;
